export default __webpack_public_path__ + "svg/logo_dark-c8300a01.svg";